// extracted by css-extract-rspack-plugin
export default {"cls1":"FacebookDisabledPage-cls1_5HP","cls2":"FacebookDisabledPage-cls2_NbZ FacebookDisabledPage-cls1_5HP"};